import { useCallback, useState } from 'react';
import { useAuth } from '../../public/site/AuthProvider.js';
import { removeMigrationSkipped } from '../../selfservice/common/localStorageUtils.js';
import { ElisaIdMigrationConfirmation } from './ElisaIdMigrationConfirmation.js';
import { ElisaIdMigrationVerifyContact } from './ElisaIdMigrationVerifyContact.js';

type Step = 'confirmed' | 'done';

export const ElisaIdMigrationFlow = () => {
  const { authenticatedUser } = useAuth();
  const [step, setStep] = useState<Step | null>(null);
  const [confirmedEmail, setConfirmedEmail] = useState('');

  const onSuccess = useCallback((email: string) => {
    setConfirmedEmail(email);
    removeMigrationSkipped();
    setStep('confirmed');
  }, []);

  const onClose = useCallback(() => {
    setStep('done');
  }, []);

  if (step === 'done' || (!authenticatedUser?.migrate && step === null)) {
    return null;
  }

  if (step === 'confirmed') {
    return <ElisaIdMigrationConfirmation userEmail={confirmedEmail} onClose={onClose} />;
  }

  return <ElisaIdMigrationVerifyContact onSuccess={onSuccess} />;
};
